import { useLocation } from "react-router-dom";
import MatchCard from "../../components/user/matchcard";
import { useState, useEffect, useRef } from "react";
import BottomNavbar from "../../components/navs/mobilenav";
import "animate.css";
import { useUserContext } from "../../context/userContext";
import api from "../../utils/axiosConfig";
import dayjs from "dayjs";
import withAuth from "../../components/user/withAuth";
import PropTypes from "prop-types";
import { openDeepLink } from "../../utils/deepLink";
import { Link } from "react-router-dom";
import group49 from "../../assets/Group 49.svg";
// import UpgradePlanModal from "../../components/modals/plans";

const MobileSignupPromptModal = ({ isOpen, onContinue }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-md flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl p-6 w-11/12 max-w-md shadow-lg">
        <h2 className="text-xl font-bold text-secondary text-center mb-4">
          Welcome to Tweezers!
        </h2>
        <p className="text-gray-600 text-sm text-center mb-6">
          Would you like to continue with your free account?
        </p>
        <div className="flex flex-col space-y-3">
          {/* Payment/Subscription flow disabled */}
          <button
            onClick={onContinue}
            className="w-full py-3 border border-gray-300 rounded-lg text-gray-700"
          >
            Continue with Free Account
          </button>
        </div>
      </div>
    </div>
  );
};

MobileSignupPromptModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onContinue: PropTypes.func.isRequired,
};

const UserDash = () => {
  const [selectedDate, setSelectedDate] = useState("Today");
  const [fixtures, setFixtures] = useState({});
  const [search, setSearch] = useState("");
  // const [modalOpen, setModalOpen] = useState(false);
  const [leagues, setLeagues] = useState([]);
  const [activeLeague, setActiveLeague] = useState("");

  const { user } = useUserContext();
  const location = useLocation();
  const [showMobileModal, setShowMobileModal] = useState(false);
  const scrollRef = useRef(null);

  const avatarUrl = `https://api.dicebear.com/7.x/identicon/svg?seed=${user?.user?.name}`;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("ismobile") === "true") {
      setShowMobileModal(true);
    }
  }, [location.search]);

  useEffect(() => {
    api.get("/fixtures/leagues").then((res) => {
      setLeagues(res.data.leagues);
    });
  }, []);

  const handleContinueFree = () => {
    openDeepLink({
      schemeUrl: "tweezers://home",
      fallbackUrls: {
        ios: "https://apps.apple.com/app/idXXXXXXXX",
        android:
          "https://play.google.com/store/apps/details?id=com.tweezers.app",
        desktop:
          "https://play.google.com/store/apps/details?id=com.tweezers.app",
      },
    });
    setShowMobileModal(false);
  };

  // const handleBuySubscription = () => {};

  const handleLeagueClick = (league) => {
    setActiveLeague(league);
    setSearch(league.toLowerCase());
  };

  useEffect(() => {
    api.get("/fixtures").then((res) => {
      const groupedFixtures = res.data.fixtures.reduce((acc, fixture) => {
        const isBasketball =
          fixture.league === "NBA" || fixture.league === "NCAA";

        const fixtureDate = dayjs(fixture?.date.split("T")[0]);
        const today = dayjs();
        const yesterday = dayjs().subtract(1, "day");
        const tomorrow = dayjs().add(1, "day");

        let dateLabel;
        if (fixtureDate.isSame(today, "day")) {
          dateLabel = "Today";
        } else if (fixtureDate.isSame(yesterday, "day")) {
          dateLabel = "Yesterday";
        } else if (fixtureDate.isSame(tomorrow, "day")) {
          dateLabel = "Tomorrow";
        } else {
          dateLabel = fixtureDate.format("DD MMM");
        }

        if (!acc[dateLabel]) {
          acc[dateLabel] = [];
        }

        acc[dateLabel].push({
          league: fixture.league,
          countryFlag: fixture.leagueEmblem,
          team1: fixture.homeTeam,
          team1Emblem: fixture.homeTeamEmblem,
          team2: fixture.awayTeam,
          team2Emblem: fixture.awayTeamEmblem,
          time: fixture.date.split("T")[1],
          resultPrediction: fixture.resultPrediction,
          ggngPrediction: fixture.ggngPrediction,
          overUnderPrediction: fixture.overUnderPrediction,
          fixtureId: fixture.fixtureId,
          played: fixture.played,
          wonResultPrediction: fixture.wonResultPrediction,
          wonGGNGPrediction: fixture.wonGGNGPrediction,
          wonOverUnderPrediction: fixture.wonOverUnderPrediction,
        });

        return acc;
      }, {});

      setFixtures(groupedFixtures);
    });
  }, []);

  const filteredSearchResults = fixtures[selectedDate]
    ? fixtures[selectedDate].filter(
        (fixture) =>
          fixture.team1.toLowerCase().includes(search.toLowerCase()) ||
          fixture.team2.toLowerCase().includes(search.toLowerCase()) ||
          fixture.league.toLowerCase().includes(search.toLowerCase())
      )
    : [];

  console.log("Search", filteredSearchResults);

  return (
    <div className="bg-gray-100 min-h-screen font-sora overflow-x-hidden">
      {/* New Purple Header - Exact Design Match */}
      <div
        className="text-white px-6 py-8 overflow-x-hidden"
        style={{ backgroundColor: "#2C0053" }}
      >
        {/* Main Header Content */}
        <div className="flex items-start justify-between mb-6">
          {/* Welcome Section - Left */}
          <div>
            <h1 className="text-white text-sm font-light mb-1">Welcome,</h1>
            <h2 className="text-white text-[17px] md:text-2xl font-bold">
              {user?.user?.name?.split(" ")[0] || "User"}
            </h2>
          </div>

          {/* User Info Section - Right */}
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center overflow-hidden">
              <img
                src={avatarUrl}
                alt="User Avatar"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Search Bar  */}
        <div className="mb-6">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-4 z-50 flex items-center pointer-events-none">
              <svg
                className="w-5 h-5 text-purple-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </div>
            <input
              type="text"
              placeholder="Search Teams"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full md:w-100 pl-12 pr-4 py-3 bg-purple-800/30 backdrop-blur-md rounded-full text-white placeholder-purple-300 border-none focus:outline-none focus:ring-0 text-sm "
              style={{
                background: "rgba(139, 69, 219, 0.2)",
                backdropFilter: "blur(20px)",
                WebkitBackdropFilter: "blur(20px)",
              }}
            />
          </div>
        </div>

        {/* Leagues Section - Always Horizontal Scroll */}
        <div className="relative">
          <div className="overflow-x-auto">
            <div
              ref={scrollRef}
              className="flex space-x-4 pb-2 "
              style={{
                scrollBehavior: "smooth",
                WebkitOverflowScrolling: "touch",
              }}
            >
              {leagues.map((league, index) => (
                <div
                  key={index}
                  onClick={() => handleLeagueClick(league.league)}
                  className={`flex-shrink-0 px-6 py-3 backdrop-blur-md rounded-full flex items-center space-x-3 cursor-pointer hover:bg-purple-700/40 transition-all min-w-fit ${
                    activeLeague === league.league ? "" : "bg-transparent"
                  }`}
                  style={
                    activeLeague === league.league
                      ? {
                          background: "rgba(139, 69, 219, 0.3)",
                          backdropFilter: "blur(20px)",
                          WebkitBackdropFilter: "blur(20px)",
                        }
                      : {}
                  }
                >
                  <img
                    src={league.emblem}
                    alt={league.league}
                    className="w-6 h-6"
                  />
                  <span className="text-white text-sm font-medium whitespace-nowrap">
                    {league.league}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Hidden elements for original functionality */}
        <div className="hidden">
          <Link to="/account/top-picks">
            <div className="flex gap-2">
              <img src={group49} alt="icon" />
              <span>Top Picks</span>
            </div>
          </Link>
        </div>

        {/* <UpgradePlanModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          userPlan={user?.user?.plan}
        /> */}
      </div>

      {/* Main Content */}
      <div className="p-6">
        {/* Date Tabs */}
        <div className="flex space-x-2 mb-4 overflow-x-auto pb-2">
          {Object.keys(fixtures).map((date) => (
            <button
              key={date}
              className={`px-4 py-2 rounded-full transition-all duration-200 ${
                selectedDate === date
                  ? "bg-green-500 text-white text-xs md:text-[14px] shadow-md"
                  : "bg-gray-200 text-xs md:text-[14px] hover:bg-gray-300"
              }`}
              onClick={() => setSelectedDate(date)}
            >
              {date}
            </button>
          ))}
        </div>

        {/* Matches Display */}
        <div className="space-y-4">
          {filteredSearchResults.length > 0 ? (
            <MatchCard matches={filteredSearchResults} />
          ) : (
            <p className="text-gray-500 text-center mt-6">No matches found.</p>
          )}
        </div>
      </div>
      <BottomNavbar />
      {/* Mobile signup prompt modal */}
      <MobileSignupPromptModal
        isOpen={showMobileModal}
        onContinue={handleContinueFree}
        // onSubscribe={handleBuySubscription}
      />
    </div>
  );
};

const AuthenticatedUserDash = withAuth(UserDash);
export default AuthenticatedUserDash;
